<main @fade>
  <nb-card>
    <nb-card-body>
      <div [nbSpinner]="loading">
        <div *ngIf="fieldsFeatures && fieldsFeatures.length && showDamFilter">
          <nb-card>
            <nb-card-body>
              <form [formGroup]="formFilter" (ngSubmit)="filterSubmit()" class="filter-catalog__center">
                <formly-form [form]="formFilter" [fields]="fieldsFeatures" [options]="options"
                             [model]="modelFeatures"></formly-form>
                <button nbButton size="small" status="primary" type="submit" i18n="@@Filter">Фильтровать</button> &nbsp;
                <button nbButton size="small" (click)="reset()" type="button" i18n="@@Cancel">Отмена</button>
              </form>
            </nb-card-body>
          </nb-card>
        </div>
        <app-dam-catalog
          [pagination]="pagination"
          [productList$]="data"
          [catalogBreadCrumbs]="catalogBreadCrumbs"
          [catalogId]="menuId"
          [fieldsFeatures]="fieldsFeatures"
          [formFilter]="formFilter"
          [options]="options"
          [modelFeatures]="modelFeatures"
          [fieldsFeaturesFast]="fieldsFeaturesFast"
          [formFilterFast]="formFilterFast"
          [optionsFast]="optionsFast"
          [modelFeaturesFast]="modelFeaturesFast"
        />
      </div>


      <ng-template #actionTpl let-row let-rowIndex="rowIndex">
        <div i18n="@@RecordDeleted" *ngIf="row.deleted !== undefined && row.deleted === true"
             class="badge text-bg-secondary" style="clear: both">запись удалена
        </div>

        <button *ngIf="row.deleted !== true && deleteCondition(row)" i18n-title="@@Delete"
                (click)="onDeleteConfirm(row.id)" title="удалить" nbButton size="small" status="control">
          <nb-icon icon="close"></nb-icon>
        </button>&nbsp;
        <button i18n-title="@@Edit" [routerLink]="['item','edit', row.id]" title="редактировать" nbButton size="small"
                status="primary">
          <nb-icon icon="edit-outline"></nb-icon>
        </button>&nbsp;
        <button i18n-title="@@Download" (click)="download(row.fileName)" title="скачать" nbButton size="small"
                status="info">
          <nb-icon icon="download-outline"></nb-icon>
        </button>
        &nbsp;
      </ng-template>
    </nb-card-body>
  </nb-card>
</main>
